'use strict';

require('./CallTimerFilter');
var CallFieldsExtension = require('./CallFieldsExtension');
var AudioControlsExtension = require('./AudioControlsExtension');
var log = require('../../log/Log').channel('CallDialPadController');
var defaults = require('../../defaults/Defaults');

angular.module('inara')
.controller('CallDialPadController', CallDialPadController);

CallDialPadController.$inject = ['$rootScope', '$scope', '$state', 
                                 'CallsService', 'ViewStateService', 
                                 'ionicMaterialInk', 'RoomService', 
                                 'KayleeService', '$ionicPopover',
                                 '$timeout', '$window', '$ionicPosition',
                                 'IosTouchEventService'];

function CallDialPadController($rootScope, $scope, $state, 
                               CallsService, ViewStateService, 
                               ionicMaterialInk, RoomService, 
                               KayleeService, $ionicPopover,
                               $timeout, $window, $ionicPosition,
                               IosTouchEventService) {
    var vm = this;
    angular.extend(vm, new CallFieldsExtension());
    angular.extend(vm, new AudioControlsExtension($scope, $ionicPopover, 
        $timeout, $window, $ionicPosition, IosTouchEventService));

    vm.dial = dial;

    log.info('initializing');

    ionicMaterialInk.displayEffect({ duration: defaults.inara.inkDuration });
    $scope.$on('$stateChangeSuccess', onStateChange);
    $rootScope.$on('CallsServiceActiveCallCountChanged',
               onActiveCallCountChanged);


    function onStateChange(event, toState, toParams, fromState, fromParams) {
        var dialPadShown = $state.includes('control.call-dialpad');
        var call = findCall(toParams.call);
        if (angular.isDefined(call)) {
            if (!angular.isDefined(call.$uiDialString)) {
                call.$uiDialString = '';
            }
            vm.call = call;
        }

        if (!dialPadShown) {
            delete vm.call;
        }
    }

    function findCall(targetCallId) {
        var activeCalls = CallsService.getActiveCalls();
        var callId;
        var call;

        for (callId in activeCalls) {
            if (activeCalls[callId].$id === targetCallId) {
                call = activeCalls[callId];
                break;
            }
        }

        return call;
    }

    function onActiveCallCountChanged() {
        if ($state.current.name === 'control.call-dialpad') {
            if (CallsService.getActiveCallCount() === 0) {
                $state.go(ViewStateService.getNoCallState());
            }
            else if (!angular.isDefined(findCall($state.params.call))) {
                $state.go(ViewStateService.getInCallState());
            }
        }
    }

    function dial(call, value) {
        if (call.callState === 'disconnecting' || call.callState === 'disconnected') return;

        call.$dial(value);
        call.$uiDialString += value;
    }
}

module.exports = CallDialPadController;
